$(document).ready(function(){
  if ($('#map').length) {

    window.BW = {};
    window.BW.PolyLineFill = PolyLineFill;


    ///Start custom poly fill code
    PolyLineFill.prototype = new google.maps.OverlayView();



    function PolyLineFill(geometry, map, fill, stroke, pattern) {
      var bounds = new google.maps.LatLngBounds();

      // console.log(geometry.getType());
      var poly = [];

      if (geometry.getType() === 'Polygon'){
        geometry.getArray().forEach(function(path){
          path.getArray().forEach(function(latLng){
            poly.push(latLng);
          });
        });
      } else if (geometry.getType() === 'MultiPolygon'){
        geometry.getArray().forEach(function(multipolygon){
          multipolygon.getArray().forEach(function(path){
          path.getArray().forEach(function(latLng){
            poly.push(latLng);
          });
        });
      });
    }


    for (var i = 0; i < poly.length; i++) {
      bounds.extend(poly[i]);
    }

    //initialize all properties.
    this.bounds_ = bounds;
    this.map_ = map;
    this.div_ = null;
    this.poly_ = poly;
    this.polysvg_ = null;
    this.fill_ = fill;
    this.stroke_ = stroke;
    this.pattern_ = pattern;


    // Explicitly call setMap on this overlay
    this.setMap(map);
  }

  PolyLineFill.prototype.onAdd = function () {
   // Create the DIV and set some basic attributes.
   var div = document.createElement('div');
   div.style.borderStyle = 'none';
   div.style.borderWidth = '0px';
   div.style.position = 'absolute';

   //createthe svg element
   var svgns = "http://www.w3.org/2000/svg";
   var svg = document.createElementNS(svgns, "svg");
   svg.setAttributeNS(null, "preserveAspectRatio", "xMidYMid meet");

   var def = document.createElementNS(svgns, "defs");

   //create the pattern fill 
   var pattern = document.createElementNS(svgns, "pattern");
   pattern.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
   if (this.pattern_ == "pattern1"){
    pattern.setAttributeNS(null, "id", "lineFill");
    pattern.setAttributeNS(null, "patternTransform", "rotate(-45)");
    pattern.setAttributeNS(null, "height", "10");
    pattern.setAttributeNS(null, "width", "10");
  } else {
    pattern.setAttributeNS(null, "id", "lineFill2");
    pattern.setAttributeNS(null, "height", "10");
    pattern.setAttributeNS(null, "width", "10");
  }
  def.appendChild(pattern);

  var rect = document.createElementNS(svgns, "rect");
  rect.setAttributeNS(null, "fill", this.fill_ || "red");
  rect.setAttributeNS(null, "fill-opacity", "0.3");
  rect.setAttributeNS(null, "stroke", this.stroke_ || "#000");
  rect.setAttributeNS(null, "stroke-opacity", "0.5");
  if (this.pattern_ == "pattern1"){
    rect.setAttributeNS(null, "id", "rectFill2");
    rect.setAttributeNS(null, "stroke-dasharray", "10,10");
    rect.setAttributeNS(null, 'stroke-width', '5');
    rect.setAttributeNS(null, "height", "10");
    rect.setAttributeNS(null, "width", "10");
  } else {
    rect.setAttributeNS(null, "id", "rectFill2");
    rect.setAttributeNS(null, 'stroke-width', '3');
    rect.setAttributeNS(null, "height", "10");
    rect.setAttributeNS(null, "width", "10");
  }
  pattern.appendChild(rect);

  svg.appendChild(def);

  // svgs.push(svg);

   //add path to the div
   var path = document.createElementNS(svgns, 'path');
   var mapUrl = window.location.href;
   if (this.pattern_ == "pattern1"){
    var lineFillUrl = mapUrl+'#lineFill';
    path.setAttributeNS(null, 'fill', 'url('+lineFillUrl+')');
  } else {
    var lineFillUrl2 = mapUrl+'#lineFill2';
    path.setAttributeNS(null, 'fill', 'url('+lineFillUrl2+')');
  }
  path.setAttributeNS(null, 'stroke', '#fff');
  path.setAttributeNS(null, 'stroke-width', '0.5');
  this.path_ = path;
  svg.appendChild(this.path_);
  svg.appendChild(this.path_);

  div.appendChild(svg);

   // Set the overlay's div_ property to this DIV
   this.div_ = div;
   this.div_.className = 'striped-polygon';

   // We add an overlay to a map via one of the map's panes.
   // We'll add this overlay to the overlayLayer pane.
   var panes = this.getPanes();
   panes.overlayLayer.appendChild(div);
  };


  PolyLineFill.prototype.AdjustPoints = function () {
   //adjust the polygon points based on the projection.
   var proj = this.getProjection();
   var sw = proj.fromLatLngToDivPixel(this.bounds_.getSouthWest());
   var ne = proj.fromLatLngToDivPixel(this.bounds_.getNorthEast());

   var points = "";
   for (var i = 0; i < this.poly_.length; i++) {
     var point = proj.fromLatLngToDivPixel(this.poly_[i]);
     if (i == 0) {
       points += (point.x - sw.x) + ", " + (point.y - ne.y);
     } else {
       points += " " + (point.x - sw.x) + ", " + (point.y - ne.y);
     }
   }
   return points;
  }


  PolyLineFill.prototype.draw = function () {
   // Size and position the overlay. We use a southwest and northeast
   // position of the overlay to peg it to the correct position and size.
   // We need to retrieve the projection from this overlay to do this.
   var overlayProjection = this.getProjection();

   // Retrieve the southwest and northeast coordinates of this overlay
   // in latlngs and convert them to pixels coordinates.
   // We'll use these coordinates to resize the DIV.
   var sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest());
   var ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast());

   // Resize the image's DIV to fit the indicated dimensions.
   var div = this.div_;
   div.style.left = sw.x + 'px';
   div.style.top = ne.y + 'px';
   div.style.width = (ne.x - sw.x) + 'px';
   div.style.height = (sw.y - ne.y) + 'px';

   this.path_.setAttributeNS(null, "d", 'M' + this.AdjustPoints() + 'z');
  }


  PolyLineFill.prototype.onRemove = function () {
   this.div_.parentNode.removeChild(this.div_);
   this.div_ = null;
  }

  ///end poly fill code


  // google.maps.event.addDomListener(window, 'load', initialize);

  }
});